<template>
    <client-page class="wrap--main">
        <!-- 메인 비주얼 -->
        <!-- <main-visual class="visual"></main-visual> -->
        <main-visual code="main-pc" sites="yknowledge" pc></main-visual>
        <main-visual code="main-mobile" sites="yknowledge" mobile></main-visual>

        <div class="main-banner">
            <div class="container">
                <div class="main-banner__con">
                    <div class="main-banner__tit" style="line-height:1;">이음자문<br /><span style="font-size:0.5em">(온라인 질의응답)</span></div>
                    <div class="main-banner__img">
                        <img src="/images/main/main-banner-process.png" alt="01질의등록>02그룹지정>03답변등록>04추가질의응답>05자문종료">
                    </div>
                </div>
            </div>
        </div>

        <div class="main-advice">
            <div class="container">
                <div class="advice-items">
                    <router-link to="/join/type" class="advice-item">
                        <div class="advice-item__inner">
                            <div class="advice-item__con">
                                <i class="icon icon-short"></i><h3 class="text-28 text-lg-22 text-md-18">회원가입</h3>
                            </div>
                        </div>
                    </router-link>
                    <router-link to="/counsel/short" class="advice-item">
                        <div class="advice-item__inner">
                            <div class="advice-item__con">
                                <i class="icon icon-long"></i><h3 class="text-28 text-lg-22 text-md-18">이음자문</h3>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <!-- 공지사항 / 자료실 -->
        <section class="main-section main-section--board">
            <div class="container">
                <div class="row main-board-row">
                    <div class="col-12 col-md-6">
                        <main-notice />
                    </div>
                    <div class="col-12 col-md-6">
                        <main-reference />
                    </div>
                </div>
            </div>
        </section>

        <!-- 참여기업 / 전문제조지원단 / 자문의뢰 / 전문가답변 -->
        <main-summary />

        <div class="main-logo">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo2.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo3.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo4.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo5.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo6.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo7.png" alt="이미지"></router-link></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="main-logo__inner"><router-link to="#"><img src="/images/main/main-logo8.png" alt="이미지"></router-link></div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <v-row justify="center">
            <v-col cols="12" align="center" class="py-0">
                <span class="subtitle-1 font-weight-bold">다국어 샘플</span> <br>
                <span class="caption">(해당 내용은 테스트하고 지우면되요)</span>
            </v-col>
            <v-col cols="auto" class="py-0">
                <locale-select label="언어변경"></locale-select>
            </v-col>
            <v-col cols="12" align="center">
                <div> 한국어 번역 경로: src/locales/ko.js </div>
                <div> 영어 번역 경로: src/locales/en.js </div>
                <div> 중국어 번역 경로: src/locales/cn.js </div>
                <div class="mt-4"> 사용법 $t() 함수 안에, src/locales/{locale}.js 에서 작성한 json 키워드 나열 </div>
                <div class="font-weight-bold mt-4">JSON 작성법1</div>
                <div>
                    {
                        "key1": "value1"
                    }
                </div>
                <div class="font-weight-bold mt-4">JSON 작성법2</div>
                <div>
                    {
                        "key1": {
                            "key2": "value2"
                        }
                    }
                </div>
                <div class="font-weight-bold mt-4">JSON 작성법3 - 우리 회사 룰 대략 아래처럼 정하죠 </div>
                <div>
                    {
                        page: {
                            section1: "내용1",
                            section2: {
                                title: "타이틀",
                                content: "내용"
                            }
                        }
                    }
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example1</div>
                    <div class="body-1">$t("common.로그인")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("common.로그인") }}</div>
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example2</div>
                    <div class="body-1">$t("main.section1")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section1") }}</div>
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example3</div>
                    <div class="body-1">$t("main.section2.title")</div>
                    <div class="body-1">$t("main.section2.content")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section2.title") }}</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section2.content") }}</div>
                </div>
            </v-col>
        </v-row> -->
        <popup-layer></popup-layer>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainBanners from "@/components/client/main/main-banners.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import PopupLayer from '@/components/client/popup/popup-layer.vue';
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import MainNotice from '@/components/client/main/main-notice.vue';
import MainReference from '@/components/client/main/main-reference.vue';
import MainSummary from '@/components/client/main/main-summary.vue';

export default {
    components: {
        ClientPage,
        MainBanners,
        MainSection,
        MainVisual,
        PopupLayer,
        LocaleSelect,
        MainNotice,
        MainReference,
        MainSummary,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    mounted(){
        this.$nextTick(() => {
            var mainLogo = new Swiper ('.main-logo .swiper-container', {
                centeredSlides: true,
                slidesPerView: 10,
                spaceBetween : 24,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 5,
                    },
                    1024: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },
                    1400: {
                        slidesPerView: 8,
                        spaceBetween: 10,
                    },
                }
            });
        });
    },
};
</script>